(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-components"] && !Shopify.designMode) return;
  try {
    (function () {
    function updateVariantForRow(row) {
      var hiddenInput = row.querySelector('.bundle-components__selected-variant');
      if (!hiddenInput || !hiddenInput.dataset.variants) return;
      var variants = JSON.parse(hiddenInput.dataset.variants);
      var selectedOptions = [];
      row.querySelectorAll('.bundle-components__pill-input:checked').forEach(function (input) {
        selectedOptions[parseInt(input.dataset.optionIndex)] = input.value;
      });
      var matched = variants.find(function (v) {
        return v.options.join('|') === selectedOptions.join('|');
      });
      if (matched) {
        hiddenInput.value = matched.id;
      }
    }

    function updateBundleVariant(listEl) {
      var bundleVariantsRaw = listEl.dataset.bundleVariants;
      if (!bundleVariantsRaw) return;
      var bundleVariants = JSON.parse(bundleVariantsRaw);

      var selectedValues = [];
      listEl.querySelectorAll('.bundle-components__pill-input:checked').forEach(function (input) {
        if (selectedValues.indexOf(input.value) === -1) {
          selectedValues.push(input.value);
        }
      });

      var matchedBundleVariant = bundleVariants.find(function (v) {
        return v.options.every(function (opt) {
          return selectedValues.indexOf(opt) !== -1;
        });
      });

      if (!matchedBundleVariant) return;

      listEl.dataset.bundleVariantId = matchedBundleVariant.id;

      var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (variantInput) variantInput.value = matchedBundleVariant.id;
    }

    function getRowTitle(row) {
      var checkedInputs = row.querySelectorAll('.bundle-components__pill-input:checked');
      var opts = [];
      checkedInputs.forEach(function (input) { opts.push(input.value); });
      return opts.join(' / ');
    }

    document.addEventListener('change', function (e) {
      var pill = e.target.closest('.bundle-components__pill-input');
      if (!pill) return;
      var row = pill.closest('.bundle-components__row');
      if (row) updateVariantForRow(row);
      var list = document.getElementById('bundle-components-list');
      if (list) updateBundleVariant(list);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      var list = document.getElementById('bundle-components-list');
      if (!list) return;

      list.querySelectorAll('.bundle-components__row').forEach(function (row) {
        var idx = row.dataset.componentIndex;
        var hiddenInput = row.querySelector('.bundle-components__selected-variant');
        if (!hiddenInput || !hiddenInput.value) return;

        var variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'properties[_component_' + idx + '_variant_id]';
        variantInput.value = hiddenInput.value;
        variantInput.classList.add('bundle-injected-property');
        form.appendChild(variantInput);

        var itemInput = document.createElement('input');
        itemInput.type = 'hidden';
        itemInput.name = 'properties[Item ' + idx + ']';
        itemInput.value = getRowTitle(row);
        itemInput.classList.add('bundle-injected-property');
        form.appendChild(itemInput);

        var imgSrc = hiddenInput.dataset.componentImage || '';
        if (imgSrc) {
          var imgInput = document.createElement('input');
          imgInput.type = 'hidden';
          imgInput.name = 'properties[_component_' + idx + '_image]';
          imgInput.value = imgSrc;
          imgInput.classList.add('bundle-injected-property');
          form.appendChild(imgInput);
        }
      });

      setTimeout(function () {
        form.querySelectorAll('.bundle-injected-property').forEach(function (el) { el.remove(); });
      }, 500);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bundle-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    function getSelectedVariantId(componentIndex, widgetId) {
      var hiddenInput = document.querySelector(
        '.bundle-widget__selected-variant[data-component-index="' + componentIndex + '"][data-widget-id="' + widgetId + '"]'
      );
      return hiddenInput ? hiddenInput.value : null;
    }

    function getComponentTitle(componentIndex, widgetId) {
      var card = document.querySelector(
        '#bundle-widget-' + widgetId + ' .bundle-widget__card[data-component-index="' + componentIndex + '"]'
      );
      if (!card) return '';
      var nameEl = card.querySelector('.bundle-widget__card-name');
      var selectEls = card.querySelectorAll('.bundle-widget__select');
      var selectedOptions = [];
      selectEls.forEach(function (sel) {
        selectedOptions.push(sel.options[sel.selectedIndex].text);
      });
      var name = nameEl ? nameEl.textContent.trim() : '';
      return selectedOptions.length > 0 ? name + ' - ' + selectedOptions.join(' / ') : name;
    }

    function updateVariantForComponent(componentIndex, widgetId) {
      var card = document.querySelector(
        '#bundle-widget-' + widgetId + ' .bundle-widget__card[data-component-index="' + componentIndex + '"]'
      );
      if (!card) return;

      var hiddenInput = card.querySelector('.bundle-widget__selected-variant');
      if (!hiddenInput || !hiddenInput.dataset.variants) return;

      var variants = JSON.parse(hiddenInput.dataset.variants);
      var selects = card.querySelectorAll('.bundle-widget__select');
      var selectedOptions = [];
      selects.forEach(function (sel) {
        selectedOptions.push(sel.value);
      });

      var matchedVariant = variants.find(function (v) {
        return v.options.join('|') === selectedOptions.join('|');
      });

      if (matchedVariant) {
        hiddenInput.value = matchedVariant.id;
        var priceEl = card.querySelector('.bundle-widget__card-price');
        if (priceEl && matchedVariant.price) {
          priceEl.textContent = formatMoney(matchedVariant.price);
        }
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function updateBundleVariant(widgetEl) {
      var bundleVariantsRaw = widgetEl.dataset.bundleVariants;
      if (!bundleVariantsRaw) return;
      var bundleVariants = JSON.parse(bundleVariantsRaw);

      // Collect all unique selected option values across all component selects in this widget
      var selectedValues = [];
      widgetEl.querySelectorAll('.bundle-widget__select').forEach(function (sel) {
        if (sel.value && selectedValues.indexOf(sel.value) === -1) {
          selectedValues.push(sel.value);
        }
      });

      // Find the bundle variant whose every option appears in the selected values
      var matchedBundleVariant = bundleVariants.find(function (v) {
        return v.options.every(function (opt) {
          return selectedValues.indexOf(opt) !== -1;
        });
      });

      if (!matchedBundleVariant) return;

      // Update the bundle variant ID on the widget and button
      widgetEl.dataset.bundleVariantId = matchedBundleVariant.id;
      var btn = widgetEl.querySelector('.bundle-widget__button');
      if (btn) btn.dataset.bundleVariantId = matchedBundleVariant.id;

      // Update bundle price display
      var priceEl = widgetEl.querySelector('.bundle-widget__price');
      if (priceEl) priceEl.textContent = formatMoney(matchedBundleVariant.price);

      // Update compare-at and savings
      var compareEl = widgetEl.querySelector('.bundle-widget__compare-price');
      var savingsEl = widgetEl.querySelector('.bundle-widget__savings');
      if (matchedBundleVariant.compare_at_price && matchedBundleVariant.compare_at_price > matchedBundleVariant.price) {
        var savings = matchedBundleVariant.compare_at_price - matchedBundleVariant.price;
        if (compareEl) { compareEl.textContent = formatMoney(matchedBundleVariant.compare_at_price); compareEl.hidden = false; }
        if (savingsEl) { savingsEl.textContent = 'You save ' + formatMoney(savings); savingsEl.hidden = false; }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (savingsEl) savingsEl.hidden = true;
      }
    }

    function handleAddBundle(button) {
      var widgetId = button.dataset.widgetId;
      var bundleVariantId = button.dataset.bundleVariantId;
      var widget = document.getElementById('bundle-widget-' + widgetId);
      var errorEl = document.getElementById('bundle-error-' + widgetId);

      if (!widget || !bundleVariantId) return;

      var componentCards = widget.querySelectorAll('.bundle-widget__card');
      var properties = {};
      var valid = true;

      componentCards.forEach(function (card) {
        var idx = card.dataset.componentIndex;
        var variantId = getSelectedVariantId(idx, widgetId);
        if (!variantId) {
          valid = false;
          return;
        }
        var title = getComponentTitle(idx, widgetId);
        properties['_component_' + idx + '_variant_id'] = variantId;
        properties['Item ' + idx] = title;
        var hiddenInput = card.querySelector('.bundle-widget__selected-variant');
        var imgSrc = hiddenInput ? (hiddenInput.dataset.componentImage || '') : '';
        if (imgSrc) properties['_component_' + idx + '_image'] = imgSrc;
      });

      if (!valid) {
        errorEl.textContent = 'Please select options for all products.';
        errorEl.hidden = false;
        return;
      }

      errorEl.hidden = true;
      button.setAttribute('aria-disabled', 'true');
      var originalText = button.querySelector('span').textContent;
      button.querySelector('span').textContent = 'Adding...';

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var formData = new FormData();
      formData.append('items[0][id]', parseInt(bundleVariantId, 10));
      formData.append('items[0][quantity]', 1);
      Object.keys(properties).forEach(function (key) {
        formData.append('items[0][properties][' + key + ']', properties[key]);
      });
      if (cart) {
        cart.getSectionsToRender().forEach(function (section) {
          formData.append('sections[]', section.id);
        });
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error adding to cart'); });
          return res.json();
        })
        .then(function (response) {
          if (cart && cart.renderContents) {
            cart.renderContents(response);
          } else {
            window.location = '/cart';
          }
          button.querySelector('span').textContent = 'Added!';
          setTimeout(function () {
            button.querySelector('span').textContent = originalText;
            button.removeAttribute('aria-disabled');
          }, 2000);
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          button.querySelector('span').textContent = originalText;
          button.removeAttribute('aria-disabled');
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bundle-widget__button');
      if (btn) handleAddBundle(btn);
    });

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('.bundle-widget__select');
      if (!sel) return;
      var componentIndex = sel.dataset.componentIndex;
      var widgetId = sel.dataset.widgetId;
      updateVariantForComponent(componentIndex, widgetId);
      var widgetEl = document.getElementById('bundle-widget-' + widgetId);
      if (widgetEl) updateBundleVariant(widgetEl);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsells"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartUpsellsInitialised) return;
    window.__cartUpsellsInitialised = true;

    document.addEventListener('click', function (evt) {
      const btn = evt.target.closest('[data-cart-upsell-add]');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const variantId = btn.dataset.variantId;
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('[cart-upsells] add failed:', response.description);
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            return;
          }
          if (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-upsells',
              productVariantId: String(variantId),
              cartData: response,
            });
            cart.renderContents(response);
          }
        })
        .catch(function (e) {
          console.error('[cart-upsells]', e);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dome-platform-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__domePlatformUpsellInitialised) return;
    window.__domePlatformUpsellInitialised = true;

    document.addEventListener('click', function (evt) {
      const btn = evt.target.closest('[data-dome-platform-add]');
      if (!btn) return;

      const variantId = btn.dataset.variantId;
      if (!variantId || btn.getAttribute('aria-disabled') === 'true') return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('Dome platform upsell: error adding to cart', response.description);
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            return;
          }
          if (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'dome-platform-upsell',
              productVariantId: String(variantId),
              cartData: response,
            });
            cart.renderContents(response);
          }
        })
        .catch(function (e) {
          console.error(e);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    // Switch gallery image based on Color option alt text (e.g. "black-ultimate", "white-ultimate")
  (function () {
    var sectionId = document.currentScript
      ? document.currentScript.closest('[data-section]')?.dataset.section
      : null;

    function initColorImageSwitch() {
      var variantSelects = document.querySelector('variant-selects[data-section]');
      if (!variantSelects) return;
      var sid = variantSelects.dataset.section;

      variantSelects.addEventListener('change', function (e) {
        var input = e.target;
        if (input.type !== 'radio') return;

        // Only act on the Color option
        var fieldset = input.closest('fieldset');
        if (!fieldset) return;
        var legend = fieldset.querySelector('legend');
        if (!legend || legend.textContent.trim().toLowerCase() !== 'color') return;

        var color = input.value.toLowerCase(); // "black" or "white"
        var gallery = document.querySelector('media-gallery');
        if (!gallery) return;

        // Find the media item whose img alt contains the color
        var mediaItems = gallery.querySelectorAll('[data-media-id]');
        var match = null;
        mediaItems.forEach(function (item) {
          var img = item.querySelector('img');
          if (img && img.alt && img.alt.toLowerCase().indexOf(color) !== -1) {
            match = item;
          }
        });

        if (match && match.dataset.mediaId) {
          gallery.setActiveMedia(match.dataset.mediaId, false);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initColorImageSwitch);
    } else {
      initColorImageSwitch();
    }
  })();

  // "Not available in this model" toast for disabled variant options
  (function () {
    var toast, hideTimer;

    function getToast() {
      if (!toast) {
        toast = document.getElementById('variant-unavailable-toast');
      }
      return toast;
    }

    function showToast(label) {
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'variant-unavailable-toast';
        toast.textContent = 'Not available in this model';
        document.body.appendChild(toast);
      }
      clearTimeout(hideTimer);

      // Position above the clicked label
      var rect = label.getBoundingClientRect();
      var tWidth = toast.offsetWidth > 0 ? toast.offsetWidth : 220;
      var left = rect.left + rect.width / 2 - tWidth / 2;
      var top = rect.top - (toast.offsetHeight || 36) - 12;

      // Clamp to viewport
      left = Math.max(8, Math.min(left, window.innerWidth - tWidth - 8));

      toast.style.left = left + 'px';
      toast.style.top = top + 'px';
      toast.classList.add('visible');
      hideTimer = setTimeout(function () { toast.classList.remove('visible'); }, 2000);
    }

    document.addEventListener('click', function (e) {
      var label = e.target.closest('label[data-unavailable-model]');
      if (label) {
        e.preventDefault();
        showToast(label);
      } else {
        var t = getToast();
        if (t) { clearTimeout(hideTimer); t.classList.remove('visible'); }
      }
    });

    window.addEventListener('scroll', function () {
      var t = getToast();
      if (t) { clearTimeout(hideTimer); t.classList.remove('visible'); }
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-choice-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__promoChoiceUpsellInitialised) return;
    window.__promoChoiceUpsellInitialised = true;

    document.addEventListener('click', function (evt) {
      const btn = evt.target.closest('[data-promo-choice-add]');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const variantId = btn.dataset.variantId;
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('properties[_promo_campaign]', btn.dataset.campaign);
      formData.append('properties[_promo_deal_number]', btn.dataset.dealNumber);
      formData.append('properties[_promo_reward_number]', btn.dataset.rewardNumber);
      formData.append('properties[_promo_discount_name]', btn.dataset.discountName);

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('[promo-choice-upsell] add failed:', response.description);
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            return;
          }
          if (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'promo-choice-upsell',
              productVariantId: String(variantId),
              cartData: response,
            });
            cart.renderContents(response);
          }
        })
        .catch(function (e) {
          console.error('[promo-choice-upsell]', e);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-single-reward-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__promoSrUpsellInitialised) return;
    window.__promoSrUpsellInitialised = true;

    document.addEventListener('click', function (evt) {
      const btn = evt.target.closest('[data-promo-sr-add]');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const variantId = btn.dataset.variantId;
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('properties[_promo_campaign]', btn.dataset.campaign);
      formData.append('properties[_promo_deal_number]', btn.dataset.dealNumber);
      formData.append('properties[_promo_reward_number]', btn.dataset.rewardNumber);
      formData.append('properties[_promo_discount_name]', btn.dataset.discountName);

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('[promo-sr-upsell] add failed:', response.description);
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            return;
          }
          if (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'promo-sr-upsell',
              productVariantId: String(variantId),
              cartData: response,
            });
            cart.renderContents(response);
          }
        })
        .catch(function (e) {
          console.error('[promo-sr-upsell]', e);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rn300-stand-upsell"] && !Shopify.designMode) return;
  try {
    // Add stand to cart when the upsell button is clicked.
  // Uses event delegation so it works after cart drawer re-renders.
  (function () {
    if (window.__rn300StandUpsellInitialised) return;
    window.__rn300StandUpsellInitialised = true;

    document.addEventListener('click', function (evt) {
      const btn = evt.target.closest('[data-rn300-stand-add]');
      if (!btn) return;

      const variantId = btn.dataset.variantId;
      if (!variantId || btn.getAttribute('aria-disabled') === 'true') return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('RN300 stand upsell: error adding to cart', response.description);
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            return;
          }
          if (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'rn300-stand-upsell',
              productVariantId: String(variantId),
              cartData: response,
            });
            cart.renderContents(response);
          }
        })
        .catch(function (e) {
          console.error(e);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
